import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    // Uit: de wachtwoord-reset-pagina heeft haar eigen, niet-persistente
    // client (zie ./supabaseResetClient.js) die als enige het
    // recovery-hash-fragment mag verwerken. Zou deze gedeelde, persistente
    // client dat ook doen, dan wordt de recovery-sessie alsnog naar
    // localStorage geschreven en overleeft hij (met refresh-token) het
    // sluiten van het tabblad — precies het lek dat de losse client
    // voorkomt. Geen andere webflow gebruikt op dit moment een
    // hash-/query-gebaseerde auth-redirect (geverifieerd: enige
    // detectSessionInUrl-afhankelijkheid was /reset-wachtwoord).
    detectSessionInUrl: false,
    autoRefreshToken: true,
  },
});
